/**
 * Not 100% sure this is actually for GA and not some other google thing, but it needs to be distinguished
 * from other google site verificaton ids
 */
export const GOOGLE_ANALYTICS_SITE_VERIFICATION_ID = "s3Im4_BFg3tdovxUlrUF-wBxOETUWT_cyCexivZtJCU";

export const GOOGLE_SEARCH_CONSOLE_SITE_VERIFICATION_ID =
  "Yks_LI5bjwUJxsGfWkvR2QfhAf4QLGx3vWitNB32SgQ";
